var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEdit = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "currentColor",
  viewBox: "0 0 20 23.91",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 19.91h5.41l14.5-14.5L14.5 0 0 14.5Zm2-2v-2.58l2.59 2.58Zm1.41-4L12 5.33l2.59 2.58L6 16.5Zm13.68-8.5L16 6.5l-2.59-2.59 1.09-1.08ZM0 21.91h20v2H0z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgEdit);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/edit.728ab08bcef63ed59f7b870895cbdf1f.svg";